import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/cancellation_policy/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import JoditEditor from "jodit-react";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

import { Offcanvas } from "react-bootstrap";

function Edit({ show, onHide, id, setId, setShowError, setSuccess, setErr }) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const nameValue = watch("name");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    GetData(id);
  }, [id]);

  const onSubmit = async (data) => {
    try {
      let response;
      if (id) {
        response = await dispatch(Update({ id, data }));
      } else {
        response = await dispatch(Create(data));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        setSuccess(true);
        setModalShow(true);
        setTimeout(() => {
          onHide();
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Country", error);
    }
  };
  const handleClose = async () => {
    if (id) {
      await GetData(id); // restore original data
    }

    clearErrors();
    onHide();
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit Cancellation Policy</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="forms_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-12 mb-3">
                <div className="form-group">
                  <Form.Label>Description</Form.Label>
                  <Controller
                    name="name"
                    control={control}
                    defaultValue=""
                    rules={{
                      validate: (value) => {
                        const text = value
                          ?.replace(/<[^>]*>/g, "")
                          ?.replace(/&nbsp;/g, "")
                          ?.trim();

                        return text?.length > 0 || "Description is required";
                      },
                    }}
                    render={({ field }) => (
                      <JoditEditor
                        value={field.value}
                        config={{
                          readonly: false,
                          placeholder: "Description",
                        }}
                        onBlur={(newContent) => field.onChange(newContent)}
                      />
                    )}
                  />

                  {errors.name && (
                    <div className="text-danger mt-1">
                      {errors.name.message}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        onHide();
                        setId();
                      }}
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <Successfull_Modal
          message={"Successful"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Edit;
